export const common = {
  // Navigation
  'nav.features': '機能',
  'nav.howItWorks': '仕組み',
  'nav.pricing': '料金',
  'nav.faq': 'FAQ',
  'nav.aboutUs': '私たちについて',
  'nav.getStarted': '始める',

  // About Us Section
  'aboutUs.badge': '私たちについて',
  'aboutUs.title': '私たちについて',
  'aboutUs.line1': 'アイデアは安い。',
  'aboutUs.line2': '資本はそうではない。時間はなおさら。',
  'aboutUs.paragraph1': 'IdeaOracle.aiは、ほとんどのビジネスアイデアが勇気の欠如ではなく、正直さの欠如で失敗するために設立されました。確認が多すぎる。現実が少なすぎる。',
  'aboutUs.belief1a': '私たちはハイプを信じません。',
  'aboutUs.belief1b': '私たちは市場論理を信じます。',
  'aboutUs.belief2a': '私たちはモチベーションを信じません。',
  'aboutUs.belief2b': '私たちは需要、競争、差別化を信じます。',
  'aboutUs.mission1': '私たちの仕事はアイデアを良く見せることではありません。',
  'aboutUs.mission2': '私たちの仕事はその実現可能性を明らかにすることです。',
  'aboutUs.analysis': 'IdeaOracle.aiは、構造的な市場メカニクス、現実的な需要、競争の激しさ、実現可能性についてビジネスニッチを分析します。感情的ではなく。楽観的ではなく。冷静に。',
  'aboutUs.failure1': 'ほとんどのアイデアは失敗します。',
  'aboutUs.failure2': '創業者が無能だからではなく –',
  'aboutUs.failure3': '事前に誰も十分に明確でなかったからです。',
  'aboutUs.clarity': '私たちはその明確さを提供するために存在します。',
  'aboutUs.value1': '不快。',
  'aboutUs.value2': '直接的。',
  'aboutUs.value3': '一貫して。',
  'aboutUs.confirm': 'アイデアに実体があれば、確認します。',
  'aboutUs.deny': 'なければ、それも伝えます。',
  'aboutUs.noApplause': '拍手なし。',
  'aboutUs.noSugarcoating': '美化なし。',
  'aboutUs.noTheater': '演劇なし。',

  // Hero Section
  'hero.badge': 'ビジネスニッチのための意思決定AI',
  'hero.title1': 'アイデアは安い。',
  'hero.title2': '悪い決断は高くつく。',
  'hero.subtitle': '投資する前に',
  'hero.subtitleLine2': 'ビジネスニッチを評価するAI。',
  'hero.cta': 'アイデアをチェック',
  'hero.ctaSecondary': '仕組み',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'リクエストごとのクレジット',
  'hero.stat2Value': '7+',
  'hero.stat2Label': '評価レベル',
  'hero.stat3Value': '100%',
  'hero.stat3Label': '正直でプライベート',

  // Features Section
  'features.title1': '強力な機能で',
  'features.title2': '現代の',
  'features.title3': 'ビジネスを支援',
  'features.honestVerdict.title': 'ハイプスコアではなく、正直な評価',
  'features.honestVerdict.description': '実際の市場データと競合調査に裏付けられた良い/中/弱いの率直な評価。あらゆるアイデアを称賛するための 9/10 評価はありません。',
  'features.fullJourney.title': 'アイデアチェックから Builder Report へ',
  'features.fullJourney.description': 'チャットで検証し、市場分析を深掘りし、ペルソナ、財務、Go-to-Market、ピッチデックを含む 25〜75 ページの Builder Report をエクスポート。',
  'features.multilingual.title': '21 言語、ローカル市場データ',
  'features.multilingual.description': 'スイスの中小企業からサンパウロのソロ創業者まで — AI はあなたの言語で、あなたの市場の情報源から回答します。',

  // How It Works
  'howItWorks.title': '仕組み',
  'howItWorks.subtitle': 'ビジネスニッチの明確化への4つのステップ。',
  'howItWorks.step1Title': 'プランを選択',
  'howItWorks.step1Desc': 'Starter、Pro、またはBuilder - レビューの深さに応じて。',
  'howItWorks.step2Title': 'AIに質問',
  'howItWorks.step2Desc': 'ニッチについて質問してください。各リクエストは30クレジットかかります。',
  'howItWorks.step3Title': '正直な評価を取得',
  'howItWorks.step3Desc': 'AIが評価：良い、普通、悪い。飾らない。',
  'howItWorks.step4Title': '決定を下す',
  'howItWorks.step4Desc': '今、前進する価値があるかどうかがわかります。',

  // Pricing
  'pricing.title': '料金',
  'pricing.subtitle': 'レビューの深さに合ったプランを選択してください。',
  'pricing.yearlyDiscount': '年間サブスクリプション：',
  'pricing.yearlyDiscountValue': '-20%割引',
  'pricing.perMonth': '月額',
  'pricing.selectPlan': 'プランを選択',
  'pricing.mostPopular': '最も人気',
  'pricing.footer': 'すべての価格はCHF。クレジットは成功したAI応答に対してのみ差し引かれます。',
  
  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.description': '初期の現実テスト用。',
  'pricing.starter.credits': '2,500クレジット',
  'pricing.starter.feature1': 'ニッチアイデアの生成',
  'pricing.starter.feature2': 'ニッチの洗練',
  'pricing.starter.feature3': '市場現実チェック',
  'pricing.starter.feature4': '競合評価',
  'pricing.starter.feature5': 'タイミング評価',
  'pricing.starter.feature6': '正直な評価',
  'pricing.starter.feature7': 'プライベートセッション',
  'pricing.starter.feature8': '履歴とエクスポート',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.description': 'より深いレビュー用。',
  'pricing.pro.credits': '5,000クレジット',
  'pricing.pro.feature1': 'すべてのStarter機能',
  'pricing.pro.feature2': '集中的なレビュー用の追加クレジット',
  'pricing.pro.feature3': '改善提案',
  'pricing.pro.feature4': '代替ニッチ',
  'pricing.pro.feature5': '詳細な市場分析',
  'pricing.pro.feature6': '優先サポート',
  'pricing.pro.feature7': '高度なフィルター',
  'pricing.pro.feature8': 'セッションのお気に入り',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.description': 'アイデア → 開発者ブリーフィング。',
  'pricing.builder.credits': '無制限クレジット',
  'pricing.builder.feature1': 'すべてのPro機能',
  'pricing.builder.feature2': '無制限のAIリクエスト',
  'pricing.builder.feature3': 'Builderモード：開発者ブリーフィング',
  'pricing.builder.feature4': '構造化されたプロジェクト概要',
  'pricing.builder.feature5': 'ユーザーフローとコア機能',
  'pricing.builder.feature6': '技術的メモ',
  'pricing.builder.feature7': '非目標の定義',
  'pricing.builder.feature8': 'フェアユースレート制限',
  'pricing.builder.limitNote': 'フェアユース制限',
  'pricing.monthlyReset': '月次リセット',

  // Modal
  'pricing.modal.selected': '選択済み',
  'pricing.modal.comingSoon': '登録と支払い処理は間もなく利用可能になります。',
  'pricing.modal.patience': '安全でシームレスな体験を提供するために取り組んでいます。お待ちください。',
  'pricing.modal.understood': '了解',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': '正直かつ批判的に回答。',
  'faq.q1': 'IdeaOracle.aiは具体的に何をしますか？',
  'faq.a1': 'IdeaOracle.aiはビジネスアイデアとニッチを市場論理、実際の需要、競争、差別化、実現可能性の観点から評価します。\n実体があれば、戦略的にどう研ぎ澄ませるかを示します。\nなければ、そう伝えます。',
  'faq.q2': 'アイデアも生成しますか？',
  'faq.a2': 'はい。\nしかし盲目的にではありません。\n市場論理に基づいたアプローチを開発します – モチベーションやトレンドのハイプではなく。',
  'faq.q3': 'ビジネスモデルを最適化しますか？',
  'faq.a3': 'はい – ポテンシャルがあれば。\n幻想を磨くことはしません。\n実行可能なコンセプトをより強固にします。',
  'faq.q4': '他のAIツールとの違いは？',
  'faq.a4': '他のツールはインスピレーションを提供します。\n私たちは評価を提供します。\n焦点はリアリズムであり、熱狂ではありません。',
  'faq.q5': '成功の保証ですか？',
  'faq.a5': 'いいえ。\n誤った判断を減らします – リスクを排除するわけではありません。',
  'faq.q6': 'IdeaOracle.aiは誰向けですか？',
  'faq.a6': 'ローンチ前の創業者\n拡大前の起業家\n時間投資前のサイドビルダー\n審査前の投資家\n\n要するに：資本の前に明確さを求める人々のために。',
  'faq.q7': '確認だけを求めている場合は？',
  'faq.a7': 'その場合、IdeaOracle.aiは適切なツールではありません。',
  'faq.q8': '分析はどれくらい正直ですか？',
  'faq.a8': 'データと市場メカニクスが許す限り正直です。\n陶酔なし。容赦なし。',
  'faq.q9': '市場調査の代わりになりますか？',
  'faq.a9': 'いいえ。\n私たちは戦略的な事前評価です – 完全な市場調査ではありません。',
  'faq.q10': 'なぜそこまで妥協しないのですか？',
  'faq.a10': '失敗は高くつくからです。\n正直さはそうではありません。',

  // Footer
  'footer.description': 'このプラットフォームは気分を良くするのではなく、正しい決定を下すのを助けます。',
  'footer.product': '製品',
  'footer.aiAssistant': 'AIアシスタント',
  'footer.howItWorks': '仕組み',
  'footer.pricing': '料金',
  'footer.faq': 'FAQ',
  'footer.legal': '法的事項',
  'footer.privacy': 'プライバシー',
  'footer.terms': '利用規約',
  'footer.imprint': 'インプリント',
  'footer.support': 'サポート',
  'footer.contact': 'お問い合わせ',
  'footer.documentation': 'ドキュメント',
  'footer.copyright': '© 2025 IdeaOracle.ai. 全著作権所有。',

  // AI Assistant
  'aiAssistant.title': 'AIニッチアシスタント',
  'aiAssistant.subtitle': 'ニッチに関する質問',
  'aiAssistant.welcomeMessage': 'こんにちは！アイデアを説明するか、ニッチについて質問してください。明確で正直な評価を提供します。',
  'aiAssistant.demoResponse': 'これはデモです。実際のAI評価を取得するには、登録してプランを選択してください。',
  'aiAssistant.placeholder': 'アイデアを説明してください...',

  // Header & Sidebar
  'dashboard.header.title': 'ダッシュボード',
  'dashboard.sidebar.overview': '概要',
  'dashboard.sidebar.newAnalysis': 'AIアシスタント',
  'dashboard.sidebar.history': '履歴',
  'dashboard.sidebar.credits': 'クレジット',
  'dashboard.sidebar.settings': '設定',

  // Dashboard Overview
  'dashboard.overview.welcome': 'おかえりなさい、{{name}}',
  'dashboard.overview.subtitle': 'アクティビティの簡単な概要です',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': '残りクレジット',
  'dashboard.stats.totalAnalyses': '総分析数',
  'dashboard.stats.goodRatings': '肯定的評価',
  'dashboard.stats.nextReset': '次のリセットまで',
  'dashboard.stats.days': '日',

  // Quick Actions
  'dashboard.quickActions.title': 'クイックアクション',
  'dashboard.quickActions.checkNewIdea': 'アイデアを確認',
  'dashboard.quickActions.checkNewIdeaDesc': '既存のビジネスアイデアを分析',
  'dashboard.quickActions.generateIdea': 'アイデアを生成',
  'dashboard.quickActions.generateIdeaDesc': '新しい収益性の高いニッチを見つける',
  'dashboard.quickActions.builderBriefing': 'Builderブリーフィング',
  'dashboard.quickActions.builderBriefingDesc': 'アイデアを開発者向けブリーフィングに変換',
  'dashboard.quickActions.premiumOnly': 'Builderのみ',

  // Chat Header
  'chat.title': 'AIニッチアシスタント',
  'chat.subtitle': 'ニッチについて質問してください。批判的かつ正直に評価します。',
  'chat.creditsLabel': 'クレジット',

  // Chat Welcome
  'chat.welcomeTitle': 'AIニッチアシスタントへようこそ',
  'chat.welcomeDesc': 'アイデアを説明するか、ニッチについて質問してください。正直に評価します：良い、普通、悪い。',
  'chat.aiWelcome': 'こんにちは！アイデアを説明するか、ニッチについて質問してください。明確で正直な評価を提供します。',

  // Chat Suggestions
  'chat.suggestion1': '収益性の高いニッチを見つけてください。',
  'chat.suggestion2': 'アイデアがあります - 正直に評価してください。',
  'chat.suggestion3': '今、どのニッチに可能性がありますか？',
  'chat.suggestion4': 'このニッチを洗練し、より具体的にしてください。',

  // Chat Actions
  'chat.newConversation': '新しい会話',
  'chat.today': '今日',
  'chat.yesterday': '昨日',
  'chat.thisWeek': '今週',
  'chat.thisMonth': '今月',
  'chat.older': '古い',
  'chat.messages': 'メッセージ',
  'chat.renameConversation': '名前を変更',
  'chat.deleteConversation': '削除',
  'chat.cancel': 'キャンセル',
  'chat.rename': '名前を変更',
  'chat.delete': '削除',
  'chat.favorite': 'お気に入りに追加',
  'chat.unfavorite': 'お気に入りから削除',
  'chat.searchSessions': '会話を検索...',
  'chat.noResults': '結果が見つかりません',
  'chat.noSessions': 'まだ会話がありません',
  'chat.enterNewName': '新しい名前を入力...',
  'chat.deleteConfirmMessage': 'この会話を削除してもよろしいですか？この操作は元に戻せません。',

  // Chat Input & Errors
  'chat.inputPlaceholder': '質問を入力してください…（30クレジットかかります）',
  'chat.send': '送信',
  'chat.voice': '話す',
  'chat.listeningPlaceholder': '聞いています...今話してください。',
  'chat.stopListening': '録音を停止',
  'chat.recording': '録音中...',
  'chat.speechNotSupported': 'お使いのブラウザは音声認識をサポートしていません。',
  'chat.microphonePermissionDenied': 'マイクへのアクセスが拒否されました。ブラウザの設定でアクセスを許可してください。',
  'chat.errorNotEnoughCredits': 'クレジットが不足しています。プランをアップグレードするか、次のリセットをお待ちください。',
  'chat.errorAiFailed': 'AI応答が失敗しました。クレジットは差し引かれていません。',
  'chat.errorRateLimit': 'リクエストが多すぎます。しばらくお待ちください。',

  // Ratings
  'rating.good': '良い',
  'rating.medium': '普通',
  'rating.bad': '悪い',

  // Auth Page
  'auth.branding.headline1': 'すべてのアイデアが良いわけではありません。',
  'auth.branding.headline2': '正直にお伝えします。',
  'auth.branding.subtitle': 'ビジネスニッチのための意思決定AI。明確。批判的。飾らない。',
  'auth.benefits.privacy.title': '100% プライベート',
  'auth.benefits.privacy.desc': 'あなたのアイデアは完全にプライベートで安全です。',
  'auth.benefits.honest.title': '正直なAI',
  'auth.benefits.honest.desc': '飾らない – 明確で批判的なフィードバックのみ。',
  'auth.benefits.fast.title': '迅速な結果',
  'auth.benefits.fast.desc': '数分でニッチについての明確さを得られます。',
  'auth.trust.users': 'アクティブユーザー',
  'auth.trust.ideas': '分析されたアイデア',
  'auth.trust.rating': '評価',
  'auth.login.title': 'ログイン',
  'auth.login.headline': 'おかえりなさい',
  'auth.login.subtitle': 'ログインして続けてください。',
  'auth.login.forgotPassword': 'パスワードをお忘れですか？',
  'auth.login.submit': 'ログイン',
  'auth.login.noAccount': 'アカウントをお持ちでないですか？',
  'auth.login.signUp': '登録',
  'auth.register.title': '登録',
  'auth.register.headline': 'アカウントを作成',
  'auth.register.subtitle': '今日からビジネスアイデアの分析を始めましょう。',
  'auth.register.submit': 'アカウント作成',
  'auth.register.hasAccount': 'すでにアカウントをお持ちですか？',
  'auth.register.signIn': 'ログイン',
  'auth.fields.name': '氏名',
  'auth.fields.email': 'メールアドレス',
  'auth.fields.password': 'パスワード',
  'auth.fields.confirmPassword': 'パスワード確認',
  'auth.fields.selectPlan': 'プランを選択',
  'auth.placeholders.name': '名前を入力',
  'auth.placeholders.email': 'メールを入力',
  'auth.placeholders.password': 'パスワードを入力',
  'auth.placeholders.confirmPassword': 'パスワードを確認',
  'auth.terms.accept': '同意します',
  'auth.terms.terms': '利用規約',
  'auth.privacy.accept': '同意します',
  'auth.privacy.policy': 'プライバシーポリシー',
  'auth.errors.nameRequired': '名前は必須です',
  'auth.errors.emailRequired': 'メールは必須です',
  'auth.errors.emailInvalid': '有効なメールを入力してください',
  'auth.errors.passwordRequired': 'パスワードは必須です',
  'auth.errors.passwordLength': 'パスワードは8文字以上必要です',
  'auth.errors.passwordMismatch': 'パスワードが一致しません',
  'auth.loading': 'お待ちください...',
  'auth.or': 'または続ける',
  'auth.social.google': 'Googleで続ける',
  'auth.social.apple': 'Appleで続ける',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': '3日間無料アクセス',
  'pricing.trial.credits': '250クレジット',
  'pricing.trial.free': '無料',
  'pricing.trial.duration': '3日間無料',
  'pricing.trial.cta': '無料トライアルを開始',
  'pricing.trial.feature1': 'AIを試せる250クレジット',
  'pricing.trial.feature2': '3日間フルアクセス',
  'pricing.trial.feature3': 'クレジットカード不要',
  'pricing.trial.feature4': 'いつでもキャンセル可能',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10,000クレジット + 25ページのBuilderレポート',
  'pricing.gold.credits': '10,000クレジット',
  'pricing.gold.feature1': '10,000クレジット',
  'pricing.gold.feature2': '25ページのBuilderレポート',
  'pricing.gold.feature3': 'Starter・Proのすべての機能',
  'pricing.gold.feature4': '市場分析とサマリー',
  'pricing.gold.feature5': 'チャンス、リスク、推奨事項',
  'pricing.gold.feature6': 'PDFダウンロード',
  'pricing.gold.feature7': 'サポート',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15,000クレジット + 100ページのBuilderレポート',
  'pricing.platinum.credits': '15,000クレジット',
  'pricing.platinum.feature1': '15,000クレジット',
  'pricing.platinum.feature2': '100ページのBuilderレポート',
  'pricing.platinum.feature3': 'Goldのすべての機能',
  'pricing.platinum.feature4': 'Builderモード:開発者ブリーフィング',
  'pricing.platinum.feature5': '構造化されたサマリー',
  'pricing.platinum.feature6': '高度な市場分析',
  'pricing.platinum.feature7': 'サポート',

  // Pricing UI
  'pricing.monthly': '月額',
  'pricing.yearly': '年額',
  'pricing.savings': 'お得',
  'pricing.billedYearly': '年一括請求',

  // Hero trial CTA
  'hero.trialTitle': '無料トライアルを始める',
  'hero.creditsLabel': 'クレジット',
  'hero.trialTagline': 'AIアシスタントを3日間無料でお試し',
  'hero.trialCta': '登録して250クレジットを獲得',
  'hero.trialNoCard': 'クレジットカード不要。契約なし。',

  // Admin
  'admin.dashboard.tabs.plans': 'プラン',

  // Credit top-up
  'dashboard.credits.topup.button': 'クレジットをチャージ',
  'dashboard.credits.topup.buttonTitle': 'プランを変更せずにクレジットを追加購入',
  'dashboard.credits.topup.title': 'クレジットをチャージ',
  'dashboard.credits.topup.subtitle': '1クレジットあたりCHF 0.15 — プラン変更不要',
  'dashboard.credits.topup.quickAmounts': 'クイック選択',
  'dashboard.credits.topup.custom': 'カスタム',
  'dashboard.credits.topup.totalLabel': '合計',
  'dashboard.credits.topup.creditsLabel': 'クレジット',
  'dashboard.credits.topup.confirm': '今すぐ購入',
  'footer.disclaimer': '免責事項',
  'legal.backToHome': 'ホームに戻る',
  'legal.lastUpdated': '最終更新',
  'legal.allRightsReserved': 'All rights reserved.',
  'legal.authoritativeNotice': 'お使いの言語のローカライズ版はまだご用意できておりません。法的拘束力を持つ英語版を以下に表示します。',
  'legal.translationNotice': 'これは参考訳です。法的拘束力を持つ正本は英語版です。',
};

export default common;
